export const Black = "#121212"
export const White = "#eeeeee"
